export enum LoanOriginationSystemTemplatesFiltersActionTypes {
  SetSearchInputValue = 'loanOriginationSystemTemplatesFiltersActionTypes/setSearchInputValue',
  FilterTemplatesByMembers = 'loanOriginationSystemTemplatesFiltersActionTypes/filterTasksByMembers',
  ResetAllFilters = 'loanOriginationSystemTemplatesFiltersActionTypes/resetAllFilters',
  ChangePopupFilters = 'loanOriginationSystemTemplatesFiltersActionTypes/changePopupFilters',
  ToggleFiltersPopup = 'loanOriginationSystemTemplatesFiltersActionTypes/toggleFiltersPopup',
}
